export const SET_USER = 'setUser'
export const SET_PACKAGES = 'setPackages'
export const SET_PACKAGE = 'setCurrentPackage'

// Products
export const SET_PRODUCTS = 'setProducts'
export const SET_CURRENT_PRODUCT = 'setCurrentProduct'

// Cart
export const SET_CART = 'setCart'
export const ADD_TO_CART = 'addToCart'
export const REMOVE_FROM_CART = 'removeFromCart'
export const UPDATE_CART_ITEM = 'updateCartItem'
export const CLEAR_CART = 'clearCart'



// WEBPACK FOOTER //
// ./src/store/mutation-types.js